import React from 'react';

import { useTranslation } from '../../hooks/use-translations';

import styles from './TermsConditions.module.scss';

const TermsConditions = () => {
  const { t } = useTranslation();
  return (
    <>
      <section>
        <div className={styles.topTitle}>
          <p>{t('ob.tnc.text')}</p>
        </div>
      </section>
    </>
  );
};

export default TermsConditions;
